import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getReceipt = (params: {
  invoiceId: number;
  type: "opd" | "ipd" | "pathology" | "pharmacy";
}) => {
  const snakeParams = camelToSnake(params);
  return api.get(`${BASE_URL}/api/v1/receipts`, { params: snakeParams });
};

export const getOpdReceiptPdf = (params: { invoiceId: number }) => {
  const snakeParams = camelToSnake(params);
  return api.get(`${BASE_URL}/api/v1/receipts/opd/pdf`, {
    params: snakeParams,
  });
};

export const getPharmacyReceiptPdf = (params: { invoiceId: number }) => {
  const snakeParams = camelToSnake(params);
  return api.get(`${BASE_URL}/api/v1/receipts/pharmacy/pdf`, {
    params: snakeParams,
  });
};

export const getPharmacyBillHtml = (params: { pharmacySaleId?: number; invoiceId?: number }) => {
  const snakeParams = camelToSnake(params);
  return api.get(`${BASE_URL}/api/v1/receipts/pharmacy/html`, {
    params: snakeParams,
    responseType: "blob",
  });
};

export const getOpdBillHtml = (params: { invoiceId: number }) => {
  const snakeParams = camelToSnake(params);
  return api.get(`${BASE_URL}/api/v1/receipts/opd/html`, {
    params: snakeParams,
    responseType: "blob",
  });
};
